import { cmsSportOrder } from "./mapper/SportDataMapper"
import { queryType } from "../../common";

export enum liveStreamingMode {
    firstSelected = "firstSelected", first = "first", last = "last"
}

export enum defaultItemForSportMode {
    favorites = "favorites", liveStreaming = "liveStreaming", firstSport = "sport"
}

export enum itemIDs {
    favorites = "favorites", liveStreaming = "streaming"
}

export type sportConfig = {
    enableAllSports: boolean,
    enableFavorites: boolean,
    enableLiveStreaming: boolean,
    liveStreamingMode: liveStreamingMode,
    isFavoritesFirst: boolean,
    hideSportIconOnMobile: boolean,
    sportOrder: cmsSportOrder[],
    query: queryType,
    sportRetrieverUpdatePeriod: number,
    liveStreamingUpdatePeriod: number,
    blockId: string,
}